export default [
    {
      reducerKey: 'recommendations/audits',
      sagaKey: 'recommendationsAuditsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/Audits/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/Audits/store/saga'),
    },
    {
      reducerKey: 'recommendations/benchmarks',
      sagaKey: 'recommendationsBenchmarksSaga',
      importReducer: () => import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/Benchmarks/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/Benchmarks/store/saga'),
    },
    {
      reducerKey: 'recommendations/types',
      sagaKey: 'recommendationsTypesSaga',
      importReducer: () =>
        import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/CampaignsRecommendations/TypesList/store/reducer'),
      importSaga: () =>
        import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/CampaignsRecommendations/TypesList/store/saga'),
    },
    {
      reducerKey: 'recommendations/type',
      sagaKey: 'recommendationsTypeSaga',
      importReducer: () =>
        import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/CampaignsRecommendations/Type/store/reducer'),
      importSaga: () =>
        import(/* webpackChunkName: "domain-recommendations" */ 'modules/Recommendations/CampaignsRecommendations/Type/store/saga'),
    },
]
